import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs: FAQItem[] = [{
    question: 'What WordPress development services do you offer?',
    answer: 'We offer comprehensive WordPress services including custom theme development, plugin development, WooCommerce setup, website migrations, performance optimization, security hardening, and ongoing maintenance and support. Our team specializes in creating fast, secure, and SEO-optimized WordPress websites tailored to your business needs.'
  }, {
    question: 'Do you develop both native and hybrid mobile apps?',
    answer: 'Yes, we develop both native apps (using Swift for iOS and Kotlin for Android) and hybrid/cross-platform apps using React Native and Flutter. We help you choose the best approach based on your specific requirements, timeline, and budget. Native apps offer the best performance, while hybrid apps provide cost-effective solutions for multi-platform deployment.'
  }, {
    question: 'How much does a website cost?',
    answer: 'Website costs vary based on complexity and requirements. A basic WordPress website starts from £500, while custom web applications and e-commerce sites range from £2,000 to £10,000+. Mobile app development typically ranges from £5,000 to £25,000+. Contact us for a free, no-obligation quote tailored to your specific project.'
  }, {
    question: 'How long does it take to build a website?',
    answer: 'A standard WordPress website typically takes 2-4 weeks from start to finish. Custom web applications take 6-8 weeks, and mobile apps take 8-12 weeks depending on complexity and features. We provide detailed timelines during our initial consultation and keep you updated throughout the development process.'
  }, {
    question: 'Do you provide ongoing support and maintenance?',
    answer: 'Yes, we offer comprehensive maintenance packages including security updates, regular backups, performance monitoring, content updates, and technical support. Our support team is available via WhatsApp for quick responses. We believe in building long-term partnerships with our clients to ensure their digital assets remain secure and up-to-date.'
  }, {
    question: 'Can you help with SEO and digital marketing?',
    answer: 'Absolutely! All our websites are built with SEO best practices in mind, including proper schema markup, optimized page speed, mobile responsiveness, and clean code structure. We also offer additional SEO services including keyword research, on-page optimization, and content strategy to help improve your search engine rankings.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-24 bg-white" data-id="element-45">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46">
        <div className="text-center mb-16" data-id="element-47">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-navy-50 rounded-full mb-6" data-id="element-48">
            <HelpCircle className="w-8 h-8 text-navy-900" data-id="element-49" />
          </div>
          <h2 className="text-base font-semibold text-blue-600 tracking-wide uppercase mb-2" data-id="element-50">
            FAQ
          </h2>
          <p className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-51">
            Frequently Asked Questions
          </p>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-52">
            Find answers to common questions about our services, pricing, and
            process.
          </p>
        </div>

        <div className="space-y-4" data-id="element-53">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm" data-id="element-54">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-navy-900 focus:ring-inset" aria-expanded={openIndex === index} data-id="element-55">
                <span className="text-lg font-semibold text-navy-900 pr-4" data-id="element-56">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-57" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-58">
                <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-59">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-60">
          <p className="text-gray-600 mb-4" data-id="element-61">Still have questions?</p>
          <a href="https://wa.me/447921876472" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 bg-whatsapp hover:bg-[#1da851] text-white font-semibold rounded-lg transition-all duration-200 shadow-md hover:shadow-lg" data-id="element-62">
            Chat with us on WhatsApp
          </a>
        </div>
      </div>
    </section>;
}